import { RxStateComponent } from '@alliance/shared/models'
import { DetectPlatformService, NgZoneHelperService } from '@alliance/shared/utils'
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { PolymorpheusContent } from '@alliance/shared/polymorpheus'
import { asyncScheduler, timer } from 'rxjs'
import { TooltipPosition } from '../models/tooltip-position-enum'
import { TooltipOrigin } from '../models/tooltip-origin-enum'

@Component({
  selector: 'santa-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TooltipComponent
  extends RxStateComponent<{
    enableTooltip: boolean
    arrowPosition: number
    tooltipIsOpen: boolean
  }>
  implements AfterViewInit
{
  @Input() public tooltipContent: PolymorpheusContent | undefined
  @Input() public tooltipContentContext: unknown

  @Input() public wrapText = false
  @Input() public fullWidth = false
  @Input() public width = 'auto'

  @Input() public tooltipPosition = TooltipPosition.bottom
  @Input() public tooltipOrigin = TooltipOrigin.center
  @Input() public tooltipOffset = 0

  @ViewChild('tooltipContainerRef') private tooltipContainerRef: ElementRef<HTMLElement> | undefined
  @ViewChild('tooltipContentRef') private tooltipContentRef: ElementRef<HTMLElement> | undefined

  public readonly tooltipPositionConfig: Record<TooltipPosition, string> = {
    [TooltipPosition.bottom]: 'tooltip-bottom',
    [TooltipPosition.right]: 'tooltip-right',
    [TooltipPosition.left]: 'tooltip-left',
    [TooltipPosition.top]: 'tooltip-top'
  }

  public readonly tooltipOriginConfig: Record<TooltipOrigin, string> = {
    [TooltipOrigin.left]: 'tooltip-origin-left',
    [TooltipOrigin.right]: 'tooltip-origin-right',
    [TooltipOrigin.center]: 'tooltip-origin-center'
  }

  public readonly state = this.connectViewState(['enableTooltip', 'arrowPosition', 'tooltipIsOpen'])

  public constructor(private platform: DetectPlatformService, private ngZoneHelper: NgZoneHelperService) {
    super()

    this.initState({
      enableTooltip: true,
      arrowPosition: 0,
      tooltipIsOpen: false
    })
  }

  @Input()
  public set enableTooltip(value: boolean) {
    this.set({ enableTooltip: value })
  }
  @Input()
  public set tooltipOpen(val: boolean) {
    this.set({ tooltipIsOpen: val })
  }

  public ngAfterViewInit(): void {
    if (this.platform.isBrowser) {
      this.hold(timer(1, asyncScheduler).pipe(this.ngZoneHelper.outsideNgZone()), () => {
        if (this.tooltipOrigin === TooltipOrigin.left || this.tooltipOrigin === TooltipOrigin.right) {
          const arrowPosition = Math.min(this.tooltipContainerRef?.nativeElement?.offsetWidth ?? 0, this.tooltipContentRef?.nativeElement?.clientWidth ?? 0) / 2

          this.set({ arrowPosition })
        }
      })
    }
  }
}
